import { createContext } from 'react'

export interface IAlternativeAppContext {
  isAlternative: boolean
}

export const AlternativeAppContext = createContext<IAlternativeAppContext>({
  isAlternative: false,
})
